import { COMPONENT_VALUE_TYPES as types } from 'shared/constants';

const propsSchema = [
  {
    key: 'enable_dynamic_text_gallery',
    label: 'Enable Dynamic Text',
    type: types.BOOLEAN,
  },
  {
    key: 'images',
    label: 'Images & Dynamic Text',
    type: types.ARRAY,
    children: [
      {
        key: 'url',
        label: 'Image Url',
        type: types.TEXT,
      },
      {
        key: 'target_url',
        label: 'Target Url',
        type: types.TEXT,
      },
      {
        key: 'dynamic_title',
        label: 'Dynamic Title',
        type: types.TEXT,
      },
      {
        key: 'dynamic_caption',
        label: 'Dynamic Caption',
        type: types.TEXTAREA,
      },
    ],
  },
  {
    key: 'images_endpoint',
    label: 'Images Endpoint',
    type: types.OBJECT,
    children:[
      {
        key: 'endpoint_url',
        label: 'Endpoint Url',
        type: types.TEXT,
      },
      {
        key: 'image_collection_field',
        label: 'Image Collection Field',
        type: types.TEXT,
      },
      {
        key: 'image_url_field',
        label: 'Image Url Field',
        type: types.TEXT,
      },
      {
        key: 'target_url_field',
        label: 'Target Url Field',
        type: types.TEXT,
      },
      {
        key: 'image_title_field',
        label: 'Image Title Field',
        type: types.TEXT,
      },
      {
        key: 'image_caption_field',
        label: 'Image Caption Field',
        type: types.TEXT,
      },
    ] 
  },
  {
    key: 'adaptive_height',
    label: 'Adapt Gallery Height to Image Size',
    type: types.BOOLEAN
  },
  {
    key: 'title',
    label: 'Static Title',
    type: types.TEXT,
  },
  {
    key: 'caption',
    label: 'Static Caption',
    type: types.TEXTAREA,
  },
  {
    key: 'bg_color',
    label: 'Background Color',
    type: types.COLOR_PICKER,
  },
];

const defaultProps = {
  enable_dynamic_text_gallery: false,
  images: [
    {
      url: 'https://genesis-cdn.ff.com/our_company/01_people/our-people-01.jpg',
      target_url: '',
      dynamic_caption: '',
      dynamic_title: '',
    },
    {
      url: 'https://genesis-cdn.ff.com/our_company/01_people/our-people-02.jpg',
      target_url: '',
      dynamic_caption: '',
      dynamic_title: '',
    },
    {
      url: 'https://genesis-cdn.ff.com/our_company/01_people/our-people-03.jpg',
      target_url: '',
      dynamic_caption: '',
      dynamic_title: '',
    },
    {
      url: 'https://genesis-cdn.ff.com/our_company/01_people/our-people-04.jpg',
      target_url: '',
      dynamic_caption: '',
      dynamic_title: '',
    },
    {
      url: 'https://genesis-cdn.ff.com/our_company/01_people/our-people-05.jpg',
      target_url: '',
      dynamic_caption: '',
      dynamic_title: '',
    },
    {
      url: 'https://genesis-cdn.ff.com/our_company/01_people/our-people-06.jpg',
      target_url: '',
      dynamic_caption: '',
      dynamic_title: '',
    },
    {
      url: 'https://genesis-cdn.ff.com/our_company/01_people/our-people-07.jpg',
      target_url: '',
      dynamic_caption: '',
      dynamic_title: '',
    }
  ],
  adaptive_height: true,
  title: '1400+',
  caption: 'Our growing international team includes more than 1,400 standout employees from diverse backgrounds spanning the technology, automotive, energy, and aerospace industries.',
  bg_color: '#f7f7f7'
};

export default {
  title: 'Descriptive Gallery',
  id: 'DescriptiveGallery',
  propsSchema,
  defaultProps
};
